<template>
  <div class="caliper-gauge row" style="height: 300px">
    <!-- <div
      class="column justify-center items-center"
      style="width: 20px; font-size: 20px; height: 300px"
    >
      活塞位置
    </div> -->
    <div
      class="column justify-center items-center text-weight-bold q-pr-md q-pl-md full-height relative-position"
      style="font-size: 20px"
    >
      <div>大间隙</div>
      <Charts
        :options="options"
        :style="{ width: chartWidth + 'px', height: chartHeight + 'px' }"
      />
      <div>小间隙</div>
    
      <div class="gauge-scale" :style="{ bottom: BOTTOM1 + 'px' }"></div>
      <div class="gauge-scale" :style="{ bottom: BOTTOM2 + 'px' }"></div>
      <div class="gauge-scale" :style="{ bottom: BOTTOM3 + 'px' }"></div>

      <div
        class="gauge-tip absolute row q-gutter-y-xs"
        :style="{
          bottom: BOTTOM1 - GAP + 'px',
        }"
      >
        <div class="col-4">{{ " " }}</div>
        <div class="col-4 text-weight-bolder" style="font-size: 14px">
          拖滞力矩
        </div>
        <div class="col-4 text-weight-bolder" style="font-size: 14px">
          响应时间
        </div>
        <div class="col-4">-{{ number1 }}mm</div>
        <div class="col-4">0Nm</div>
        <div class="col-4">90ms</div>
      </div>

      <div
        class="gauge-tip row"
        :style="{
          bottom: BOTTOM2 - GAP + 'px',
        }"
      >
        <div class="col-4">-{{ number2 }}mm</div>
        <div class="col-4">0.2Nm</div>
        <div class="col-4">70ms</div>
      </div>
      <div
        class="gauge-tip row"
        :style="{
          bottom: BOTTOM3 - GAP + 'px',
        }"
      >
        <div class="col-4">-{{ number3 }}mm</div>
        <div class="col-4">50Nm</div>
        <div class="col-4">35ms</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import Charts from "@/components/Charts";
import { getChartsDefaultOptions, chartWidth, chartHeight } from "./helper";
import { limitUIRx_BrakeAirGap } from "@/views/DomainControl/helper/ada";

const number1 = 0.4;
const number2 = 0.3;
const number3 = 0.05;
const BOTTOM1 = chartHeight * (number1 / 0.5) + 30;
const BOTTOM2 = chartHeight * (number2 / 0.5) + 30;
const BOTTOM3 = chartHeight * (number3 / 0.5) + 30;
const GAP = 8;

interface Props {
  value: number;
}
const props = withDefaults(defineProps<Props>(), {
  value: 0,
});
const options = computed(() => {
  const value = limitUIRx_BrakeAirGap(props.value);
  const opions = getChartsDefaultOptions(value);
  return opions;
});
</script>
<style scoped>
.caliper-gauge {
  width: 100%;
}
.gauge-tip {
  width: 250px;
  position: absolute;
  /* border-bottom: 2px solid #8f8f8f; */
  padding-left: 60px;
  left: 20px;
  font-size: 12px;
}
.gauge-scale {
  width: 50px;
  border-bottom: 2px solid #f44336;
  position: absolute;
}
.col-4 {
  text-align: center;
}
</style>
